var m = localStorage.getItem("contact");
//var m = "云视频";
import carLocate from "@/components/locate/carLocate.vue";
import allLocate from "@/components/locate/allLocate";
import personLocate from "@/components/locate/personLocate";
import locus from "@/components/locus/";
import water from "@/components/water/index";
import locusPeson from "@/components/locusPeson/";
import carVideo from "@/components/video/carVideo.vue";
import byVideo from "@/components/video/byVideo.vue";
import carVideoHistory from "@/components/video/carVideoHistory.vue";
import byCarVideoHistory from "@/components/video/byCarVideoHistory.vue";
import oil from "../../node_modules/common/src/components/oil/oil";
import temp from "../../node_modules/common/src/components/temp/";
var data = [
  {
    path: "/carLocate",
    component: carLocate,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/locus",
    component: locus,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/carLocate1",
    component: allLocate,
  },
  {
    path: "/oil",
    component: oil,
  },
  {
    path: "/temp",
    component: temp,
  },

  {
    path: "/water",
    component: water,
  },
  {
    path: "/personLocate",
    component: personLocate,
  },
  {
    path: "/personLocate1",
    component: personLocate,
  },
  {
    path: "/locusPeson",
    component: locusPeson,
  },
  {
    path: "/carVideo",
    component: m == "云视频" ? byVideo : carVideo,
  },
  {
    path: "/carVideo-A",
    component: m == "云视频" ? byVideo : carVideo,
  },
  {
    path: "/carVideoHistory",
    component: m == "云视频" ? byCarVideoHistory : carVideoHistory,
  },
  {
    path: "/carVideoHistory-A",
    component: m == "云视频" ? byCarVideoHistory : carVideoHistory,
  },
  {
    path: "/carVideoHistory",
    component: byCarVideoHistory,
  },
  /*   {
    path: "/rule/gaofeng",
    component: () => import("@/components/rule/ruleGaofeng")
  } */
];
export default data;



// WEBPACK FOOTER //
// ./src/router/locateLocus.js